<script>
	import { siteTitle } from '$lib/stores/nav';

	import { onMount } from 'svelte';

	onMount(() => {
		$siteTitle = 'Nutzungsbedingungen';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Nutzungs&shy;bedingungen</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h2>Benutzer*innen-Konto:</h2>
		<div class="rte">
			<p>
				Für die Registrierung Ihres Benutzer*innen-Kontos ist die Angabe einer
				E-Mail-Adresse, eines Benutzer*innen-Namens und eines Passworts erforderlich. Bitte
				beachten Sie, dass Ihr selbstgewählter Benutzer*innen-Name öffentlich sichtbar ist
				und jede Ihrer Crowd-Aktivitäten auf dieser Plattform mit Ihrem Benutzer*innen-Namen
				veröffentlicht wird. Die Registrierung darf nur persönlich vorgenommen werden. Eine
				automatisierte Erstellung von Konten ist nicht gestattet. Jede*r Benutzer*in
				verpflichtet sich, im Rahmen seiner/ihrer Anmeldung nicht die Rechte Dritter zu
				verletzen. Eine Verletzung der Rechte Dritter ist unter anderem dann gegeben, wenn
				personenbezogene Informationen oder sonstige Daten Dritter (z. B. der Name oder die
				E-Mail-Adresse) ohne deren Einwilligung verwendet werden.
			</p>
			<p>
				Ihre personenbezogenen Daten werden von der Stadt Wien – Wienbibliothek im Rathaus
				streng vertraulich behandelt (Details siehe Datenschutz).
			</p>
			<p>
				Als Benutzer*in sind Sie für alle Ihre Aktivitäten verantwortlich. Bezogen auf Ihre
				Aktivitäten halten Sie die Stadt Wien – Wienbibliothek im Rathaus bei allfälligen
				Inanspruchnahmen durch Dritte schad- und klaglos. Wir ersuchen Sie daher, Ihre
				Login-Daten vertraulich zu behandeln und nicht an Dritte weiterzugeben. Sollten Sie
				von einem Missbrauch Ihres Kontos oder von einem Sicherheitsproblem erfahren, bitten
				wir Sie um Mitteilung an <a href="mailto:crowdsourcing@wienbibliothek.at"
					>crowdsourcing@wienbibliothek.at</a
				>. Bei Missbrauch Ihres Kontos wird Ihr Konto von uns gesperrt oder gelöscht.
			</p>
			<p>
				Die Stadt Wien – Wienbibliothek im Rathaus behält sich vor, Sie zum Zwecke von
				Informationen zu unserer Crowdsourcing-Aktion via angegebener E-Mail-Adresse zu
				kontaktieren.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Haftungs&shy;ausschluss:</h2>
		<div class="rte">
			<p>
				Die Informationen auf dieser Website wurden mit großer Sorgfalt zusammengestellt.
				Für Richtigkeit, Vollständigkeit und Aktualität der Angaben kann die Stadt Wien –
				Wienbibliothek im Rathaus jedoch weder eine Garantie noch Haftung übernehmen.
			</p>
			<p>
				Für die Beiträge der Benutzer*innen übernimmt die Stadt Wien – Wienbibliothek im
				Rathaus keine Verantwortung. Gleiches gilt auch für alle von der Stadt Wien –
				Wienbibliothek im Rathaus oder von den Benutzer*innen eingestellten Links zu anderen
				Websites. Da die Stadt Wien – Wienbibliothek im Rathaus auf den Inhalt dieser
				Websites keinen Einfluss hat, übernimmt sie dafür keine Verantwortung.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Rechte&shy;übertragung:</h2>
		<div class="rte">
			<p>
				Benutzer*innen stimmen mit dem Speichern der eingegebenen Metadaten zu den
				Theaterzetteln der unwiderruflichen und unentgeltlichen Übertragung sämtlicher
				Nutzungs- und Bearbeitungsrechte (u.a. Vervielfältigungs-, Verbreitungs-, Sende- und
				Zurverfügungstellungsrecht sowie Recht der öffentlichen Wiedergabe) an allen
				Texten/gespeicherten Inhalten unbefristet, weltweit und exklusiv an die Stadt Wien –
				Wienbibliothek im Rathaus zu (Werknutzungsrechte). Die Nutzung von Bearbeitungen
				durch die Stadt Wien – Wienbibliothek im Rathaus und von ihr ermächtigen Dritten ist
				gestattet. Die Stadt Wien – Wienbibliothek im Rathaus ist berechtigt, sämtliche der
				ihr zukommenden Nutzungs- und Bearbeitungsrechte Dritten zu übertragen. Darüber
				hinaus stimmen die Benutzer*innen zu, dass die Texte auf dieser Plattform der
				Allgemeinheit zur Weiterverwendung zur Verfügung gestellt werden. Die Stadt Wien –
				Wienbibliothek im Rathaus behält sich außerdem das Recht vor, die eingegebenen
				Metadaten zu den Theaterzetteln ohne Nennung der Urheber*innen selbst oder durch
				Dritte weiterzuverwenden.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Weiter&shy;verwendung durch Dritte:</h2>
		<div class="rte">
			<p>
				Die zur Erfassung zur Verfügung gestellten Theaterzettel entstammen der <a
					href="https://digital.wienbibliothek.at/"
					target="_blank"
					rel="noreferrer">Wienbibliothek Digital</a
				>. Diese Theaterzettel sind alle urheberrechtsfrei und können somit frei
				weiterverwendet werden.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Abbildungen der Spiel&shy;stätten:</h2>
		<div class="rte">
			<p>
				Die Abbildungen der Spielstätten sind der Online-Sammlung des Wien Museums
				entnommen. Die Abbildungen sind der <a
					href="https://creativecommons.org/publicdomain/zero/1.0/deed.de"
					target="_blank"
					rel="noopener noreferrer">CC0 1.0</a
				> Lizenz entsprechend weiterverwendbar.
			</p>
			<ul>
				<li>
					Burgtheater Wien: Kilophot (K. L.) (Hersteller), Blick auf Wien mit dem
					Burgtheater, um 1925, Wien Museum Inv.-Nr. 169565, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/342829/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/342829/</a
					>)
				</li>
				<li>
					Neues Theater in der Scala: Martin Gerlach jun. (Fotograf), Scala-Theater (4.,
					Favoritenstraße 8), Außenansicht, um 1938–1940, Wien Museum Inv.-Nr. 211332, CC0
					(<a
						href="https://sammlung.wienmuseum.at/objekt/26699/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26699/</a
					>)
				</li>
				<li>
					Raimund Theater: Martin Gerlach jun. (Fotograf), Raimundtheater (6., Wallgasse
					18-20), Außenansicht, um 1938–1940, Wien Museum Inv.-Nr. 211328, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26695/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26695/</a
					>)
				</li>
				<li>
					Renaissancetheater: Martin Gerlach jun. (Fotograf), Renaissancetheater, 7.,
					Neubaugasse 36, Portal, um 1940, Wien Museum Inv.-Nr. 211279, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26646/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26646/</a
					>)
				</li>
				<li>
					Ronacher: Martin Gerlach jun. (Fotograf), Etablissement Ronacher (1.,
					Seilerstätte 9), Außenansicht, um 1938–1940, Wien Museum Inv.-Nr. 211327, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26694/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26694/</a
					>)
				</li>
				<li>
					Schönbrunner Schlosstheater: Martin Gerlach jun. (Fotograf), Schönbrunner
					Schloßtheater (13., Schloß Schönbrunn), Außenansicht, um 1940, Wien Museum
					Inv.-Nr. 211268, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26635/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26635/</a
					>)
				</li>
				<li>
					Theater an der Wien: Martin Gerlach jun. (Fotograf), Theater an der Wien (6.,
					Millöckergasse), Papagenotor, um 1940, Wien Museum Inv.-Nr. 211297, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26664/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26664/</a
					>)
				</li>
				<li>
					Theater in der Josefstadt: Martin Gerlach jun. (Fotograf), Theater in der
					Josefstadt (8., Josefstädter Straße 26), Außenansicht, um 1940, Wien Museum
					Inv.-Nr. 211263, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26630/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26630/</a
					>)
				</li>
				<li>
					Volkstheater Wien: Martin Gerlach jun. (Fotograf), Volkstheater ( 7.,
					Neustiftgasse 1), Außenansicht, um 1940, Wien Museum Inv.-Nr. 211251, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26618/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26618/</a
					>)
				</li>
				<li>
					Volksoper Wien: August Stauda (Fotograf), 9., Währinger Straße 78 - Volksoper,
					um 1899, Wien Museum Inv.-Nr. 105018/63, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/182003/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/182003/</a
					>)
				</li>
				<li>
					Wiener Bürgertheater: Martin Gerlach jun. (Fotograf), Bürgertheater (3., Vordere
					Zollamtsstraße 13), Außenansicht, um 1938–1940, Wien Museum Inv.-Nr. 211325, CC0
					(<a
						href="https://sammlung.wienmuseum.at/objekt/26692/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26692/</a
					>)
				</li>
				<li>
					Wiener Kammerspiele: Martin Gerlach jun. (Fotograf), Wiener Kammerspiele, 1.,
					Rotenturmstraße 20, Portal, um 1938–1940, Wien Museum Inv.-Nr. 211286, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26653/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26653/</a
					>)
				</li>
				<li>
					Wiener Staatsoper: Martin Gerlach jun. (Fotograf), Staatsoper (1., Opernring 2),
					Außenansicht, um 1940, Wien Museum Inv.-Nr. 211271, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26638/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26638/</a
					>)
				</li>
				<li>
					Wiener Stadttheater: Martin Gerlach jun. (Fotograf), Wiener Stadttheater (8.,
					Laudongasse 36), Außenansicht, um 1940, Wien Museum Inv.-Nr. 211256, CC0 (<a
						href="https://sammlung.wienmuseum.at/objekt/26623/"
						target="_blank"
						rel="noopener noreferrer">https://sammlung.wienmuseum.at/objekt/26623/</a
					>)
				</li>
			</ul>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Laufzeit:</h2>
		<div class="rte">
			<p>
				Die Crowdsourcing-Website der Stadt Wien - Wienbibliothek im Rathaus steht zeitlich
				begrenzt zur Verfügung. Benutzer*innen haben keinen Anspruch auf die permanente
				Erreichbarkeit des Services und Ihres Benutzer*innen-Kontos. Es bleibt der Stadt
				Wien - Wienbibliothek im Rathaus jederzeit freigestellt, die Seite zeitweise oder
				dauerhaft abzuschalten sowie die dort gespeicherten Inhalte zu löschen, zu verändern
				oder zu ergänzen.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Rechtliche Schritte:</h2>
		<div class="rte">
			<p>
				Bei Zuwiderhandeln gegen Bestimmungen dieser Nutzungsbedingungen behält sich die
				Stadt Wien – Wienbibliothek im Rathaus rechtliche Schritte vor. Im Falle von
				Rechtsstreitigkeiten ist das sachlich zuständige Gericht am Sitz der Stadt Wien,
				Wien 1., Rathaus, ausschließlich zuständig. Es gilt die Anwendung österreichischen
				Rechtes unter Ausschluss der Kollisionsnormen als vereinbart.
			</p>
		</div>
	</section>
</div>
